import { useEffect, useRef, useState } from 'react';

/**
 * Hook takes a media query string and returns whether or not the query matches the current viewport.
 */
export const useMediaQuery = (query: string) => {
  const mediaQueryListRef = useRef<MediaQueryList | null>(null);
  if (!mediaQueryListRef.current || mediaQueryListRef.current.media !== query) {
    mediaQueryListRef.current = window.matchMedia(query);
  }

  const mediaQueryList = mediaQueryListRef.current;

  const [matches, setMatches] = useState(mediaQueryList.matches);

  useEffect(() => {
    setMatches(mediaQueryList.matches);

    // mediaQueryList will emit an onChange event if the provided media query's status changes!
    const onMediaQueryChange = (e: MediaQueryListEvent) => {
      setMatches(e.matches);
    };
    mediaQueryList.addEventListener('change', onMediaQueryChange);

    return () => {
      mediaQueryList.removeEventListener('change', onMediaQueryChange);
    };
  }, [mediaQueryList, query]);

  return matches;
};
